import React from 'react';
import { StyleSheet, Text, TouchableHighlight, View } from './base_components';

const styles = StyleSheet.create({
  tabSelect: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.5rem',
    overflow: 'hidden',
  },
  tabButton: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  first: {
    marginLeft: 0,
  },
  last: {
    marginRight: 0,
    borderRightWidth: 0,
  },
  highlight: {
    flex: 1,
    alignSelf: 'stretch',
  },
  buttonActive: {
    flex: 1,
    alignSelf: 'stretch',
    backgroundColor: '#0a60fe',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    flex: 1,
    alignSelf: 'stretch',
    backgroundColor: '#ccc',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textActive: {
    color: 'white',
    fontSize: '1.4rem',
    fontWeight: 'bold',
  },
  text: {
    color: 'black',
    fontSize: '1.4rem',
    fontWeight: 'bold',
  },
});

type Props = {
  style?: any;
  buttonStyle?: any;
  tabs: any;
  value: string;
  onSelect: (value: string) => void;
};
type State = {};

export default class TabSelect extends React.PureComponent<Props, State> {
  render() {
    const { style, buttonStyle, tabs, value, onSelect } = this.props;
    const buttons = tabs.map((tab, i) => {
      let extra;
      if (i === 0) {
        extra = styles.first;
      } else if (i === tabs.length - 1) {
        extra = styles.last;
      }
      return (
        <TabButton
          key={i}
          style={[buttonStyle, extra]}
          isActive={value === tab.value}
          text={tab.text}
          value={tab.value}
          onSelect={onSelect}
        />
      );
    });
    return <View style={[styles.tabSelect, style]}>{buttons}</View>;
  }
}

function TabButton(props) {
  const { style, isActive, text, value, onSelect } = props;
  function _onPress() {
    onSelect(value);
  }
  const button_style = isActive ? styles.buttonActive : styles.button;
  const text_style = isActive ? styles.textActive : styles.text;
  const underlay = isActive ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)';

  return (
    <View style={[styles.tabButton, style]}>
      <TouchableHighlight
        style={styles.highlight}
        underlayColor={underlay}
        onPress={_onPress}
      >
        <View style={button_style}>
          <Text style={text_style}>{text}</Text>
        </View>
      </TouchableHighlight>
    </View>
  );
}
